import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@tinct/web-components';
import { TrendingDown, TrendingUp } from 'lucide-react';
import { ReactNode } from 'react';

export type ComparisonBadge = {
  value: string;
  label: string;
  trend: 'up' | 'down';
  tooltip?: ReactNode;
};

export function ComparisonBadges({ badges }: { badges: ComparisonBadge[] }) {
  return (
    <div className="flex w-full items-center gap-4">
      {badges.map((badge) => {
        const pair = (
          <div key={badge.label} className="flex items-center gap-1">
            <Badge variant="secondary" className="rounded-md gap-1">
              {badge.trend === 'up' ? (
                <TrendingUp className="size-3 text-emerald-500" />
              ) : (
                <TrendingDown className="size-3 text-rose-500" />
              )}
              {badge.value}
            </Badge>
            <span className="text-xs text-muted-foreground">{badge.label}</span>
          </div>
        );

        if (!badge.tooltip) return pair;

        return (
          <Tooltip key={badge.label}>
            <TooltipTrigger asChild>{pair}</TooltipTrigger>
            <TooltipContent>{badge.tooltip}</TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
